import { render, staticRenderFns } from "./ActionAnswerComplete.vue?vue&type=template&id=3c501a73&"
import script from "./ActionAnswerComplete.vue?vue&type=script&lang=ts&"
export * from "./ActionAnswerComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports